import WhatsappCheckbox from './WhatsappCheckbox'

export default WhatsappCheckbox
